import { connect } from 'react-redux';

import { selectIsDesktop } from 'selectors/ui';

import Column from './Column';

const mapStateToProps = state => ({
  isDesktop: selectIsDesktop(state),
});

export default connect(mapStateToProps)(Column);
